import React from "react";
import { useTranslation } from "react-i18next";
import PasswordLoginForm from "../PasswordLogin/PasswordLoginForm";

/**
 * Inline phone + password login rendered INSIDE the nav drawer (never a page, never a second
 * overlay). Uses the shared PasswordLoginForm in "account" mode, so it also offers
 * "New here? Create account" and Forgot password.
 *
 * There is no inline success screen — a successful login sets `user`, which flips `loggedIn` in
 * CustomDrawer and re-renders NavDrawer into its signed-in branch (the drawer is the destination).
 *
 * The phone field doesn't grab focus when the drawer opens (that pops the keyboard on someone who
 * may only want to browse). The one exception: opened from a "Log in to save" prompt, the drawer
 * bumps focusPhoneTick once its slide-in has finished.
 */
const DrawerLogin = ({ focusPhoneTick = 0 }) => {
  const { t } = useTranslation();

  return (
    <div className="px-[14px] pt-[2px] pb-[12px]">
      <div className="text-[13px] font-[500] text-ink-900 mb-2">
        {t("drawerLogin.logIn")}{" "}
        <span className="font-[400] text-ink-500">{t("drawerLogin.logInSub")}</span>
      </div>
      <PasswordLoginForm mode="account" compact focusTick={focusPhoneTick} />
    </div>
  );
};

export default DrawerLogin;
